/* eslint-disable */
import Button from "@material-ui/core/Button";
import DialogContentText from "@material-ui/core/DialogContentText";
import { categoryUrl } from "@saleor/categories/urls";
import { collectionUrl } from "@saleor/collections/urls";
import ActionDialog from "@saleor/components/ActionDialog";
import AssignCategoriesDialog from "@saleor/components/AssignCategoryDialog";
import AssignCollectionDialog from "@saleor/components/AssignCollectionDialog";
import AssignProductDialog from "@saleor/components/AssignProductDialog";
import AssignVariantDialog from "@saleor/components/AssignVariantDialog";
import { WindowTitle } from "@saleor/components/WindowTitle";
import { DEFAULT_INITIAL_SEARCH_DATA, PAGINATE_BY } from "@saleor/config";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import usePaginator, {
  createPaginationState
} from "@saleor/hooks/usePaginator";
// import useShop from "@saleor/hooks/useShop";
import { commonMessages, sectionNames } from "@saleor/intl";
// import { SearchCornermarks_search_edges_node } from "@saleor/searches/types/SearchCornermarks";
import useCategorySearch from "@saleor/searches/useCategorySearch";
import useCollectionSearch from "@saleor/searches/useCollectionSearch";
// import useCornermarkSearch from "@saleor/searches/useCornermarkSearch";
import useProductSearch from "@saleor/searches/useProductSearch";
import useProductVariantSearch from "@saleor/searches/useProductVariantSearch";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import { mapEdgesToItems } from "@saleor/utils/maps";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import {
  // decimal, joinDateTime,
  maybe
} from "../../misc";
import { productUrl, productVariantEditUrl } from "../../products/urls";
// import {
//   // CornerMarkTypeEnum,
//   DiscountValueTypeEnum,
//   SaleType
// } from "../../types/globalTypes";
import SaleDetailsPage, {
  ProductTagDetailsPageFormData,
  ProductTageDetailsPageTab
} from "../components/ProductTagsDetailsPage";
// import { sale } from "../fixtures";
import {
  // TypedSaleCataloguesAdd,
  // TypedSaleCataloguesRemove,
  // TypedSaleDelete,
  // TypedSaleProductUpdate,
  // TypedSaleUpdate
  TypedproducttagsDeleteCataloguesMutation,
  TypedproducttagsUpdateMutation,
  TypedproducttagsAddCataloguesMutation,
  TypedRemoveProducttags
} from "../mutations";
import { TypedproducttagQuery } from "../queries";
import { ProducttagsAddCatalogues } from "../types/ProducttagsAddCatalogues";
import { ProducttagsDeleteCatalogues } from "../types/ProducttagsDeleteCatalogues";
import { RemoveProducttags } from "../types/RemoveProducttags";
// import { SaleDelete } from "../types/SaleDelete";
// import { SaleProductUpdate } from "../types/SaleProductUpdate";
import { UpdateProducttags } from "../types/UpdateProducttags";
import {
  // saleListUrl,
  producttagsListUrl,
  productTageseUrl,
  // saleUrl,
  // SaleUrlDialog,
  ProductTagsUrlDialog,
  productTageQueryParams
  // SaleUrlQueryParams
} from "../urls";
import { TagValueTypeEnum } from "./ProductTagsCreate";

interface SaleDetailsProps {
  id: string;
  params: productTageQueryParams;
}

// function discountValueTypeEnum(type: SaleType): DiscountValueTypeEnum {
//   return type.toString() === DiscountValueTypeEnum.FIXED
//     ? DiscountValueTypeEnum.FIXED
//     : type.toString() === DiscountValueTypeEnum.CUSTOM
//     ? DiscountValueTypeEnum.CUSTOM
//     : DiscountValueTypeEnum.PERCENTAGE;
// }

export const SaleDetails: React.FC<SaleDetailsProps> = ({ id, params }) => {
  const navigate = useNavigator();
  const paginate = usePaginator();
  const notify = useNotifier();
  // const shop = useShop();
  const { isSelected, listElements, reset, toggle, toggleAll } = useBulkActions(
    params.ids
  );
  const intl = useIntl();
  const {
    loadMore: loadMoreCategories,
    search: searchCategories,
    result: searchCategoriesOpts
  } = useCategorySearch({
    variables: DEFAULT_INITIAL_SEARCH_DATA
  });
  const {
    loadMore: loadMoreCollections,
    search: searchCollections,
    result: searchCollectionsOpts
  } = useCollectionSearch({
    variables: DEFAULT_INITIAL_SEARCH_DATA
  });
  const {
    loadMore: loadMoreProducts,
    search: searchProducts,
    result: searchProductsOpts
  } = useProductSearch({
    variables: DEFAULT_INITIAL_SEARCH_DATA
  });
  const {
    loadMore: loadMoreProductVariants,
    search: searchProductVariants,
    result: searchProductVariantsOpts
  } = useProductVariantSearch({
    variables: DEFAULT_INITIAL_SEARCH_DATA
  });
  // const {
  //   loadMore: loadMoreCornermarks,
  //   search: searchCornermark,
  //   result: searchCornermarkOpts
  // } = useCornermarkSearch({
  //   variables: {
  //     ...DEFAULT_INITIAL_SEARCH_DATA,
  //     type: CornerMarkTypeEnum.NORMAL
  //   }
  // });
  const paginationState = createPaginationState(PAGINATE_BY, params);
  const changeTab = (tab: ProductTageDetailsPageTab) => {
    reset();
    navigate(
      productTageseUrl(id, {
        activeTab: tab
      })
    );
  };

  // const handleSaleDelete = (data: SaleDelete) => {
  //   if (data.saleDelete.errors.length === 0) {
  //     notify({
  //       status: "success",
  //       text: intl.formatMessage({
  //         defaultMessage: "Removed sale"
  //       })
  //     });
  //     navigate(saleListUrl(), true);
  //   }
  // };

  const handlePruducttagsUpdate = (data: UpdateProducttags) => {
    if (data.producttagsUpdate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
    }
  };
  // const handleSaleProcutUpdate = (data: SaleProductUpdate) => {
  //   if (data.saleProductUpdate.errors.length === 0) {
  //     notify({
  //       status: "success",
  //       text: intl.formatMessage(commonMessages.savedChanges)
  //     });
  //   }
  // };

  const [openModal, closeModal] = createDialogActionHandlers<
    ProductTagsUrlDialog,
    productTageQueryParams
  >(navigate, params => productTageseUrl(id, params), params);

  const handleCatalogueAdd = (data: ProducttagsAddCatalogues) => {
    if (data.producttagsAddCatalogues.producttagsErrors.length === 0) {
      // if (data.producttagsAddCatalogues.producttagsErrors === []) {
      closeModal();
      window.location.reload();
    }
  };

  const handleCatalogueRemove = (data: ProducttagsDeleteCatalogues) => {
    if (data.producttagsDeleteCatalogues.producttagsErrors.length === 0) {
      closeModal();
      reset();
    }
  };
  const handleRemoveProducttags = (data: RemoveProducttags) => {
    if (data.producttagsDelete.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate(producttagsListUrl(), true);
    }
  };

  const canOpenBulkActionDialog = maybe(() => params.ids.length > 0);

  return (
    <TypedproducttagsDeleteCataloguesMutation
      onCompleted={handleCatalogueRemove}
    >
      {(saleCataloguesRemove, saleCataloguesRemoveOpts) => (
        <TypedproducttagsAddCataloguesMutation onCompleted={handleCatalogueAdd}>
          {(saleCataloguesAdd, saleCataloguesAddOpts) => (
            <TypedproducttagsUpdateMutation
              onCompleted={handlePruducttagsUpdate}
            >
              {(saleUpdate, saleUpdateOpts) => (
                <TypedRemoveProducttags onCompleted={handleRemoveProducttags}>
                  {(removeProducttags, RemoveProducttagsOpts) => (
                    <TypedproducttagQuery
                      displayLoader
                      variables={{ id, ...paginationState }}
                    >
                      {({ data, loading }) => {
                        const tabPageInfo =
                          params.activeTab ===
                          ProductTageDetailsPageTab.variants
                            ? // ? maybe(() => data.producttag.variants.pageInfo)
                              // : maybe(() => data.producttag.products.pageInfo);
                              maybe(() => data.producttag.variants.pageInfo)
                            : params.activeTab ===
                              ProductTageDetailsPageTab.collections
                            ? maybe(() => data.producttag.collections.pageInfo)
                            : params.activeTab ===
                              ProductTageDetailsPageTab.categories
                            ? maybe(() => data.producttag.categories.pageInfo)
                            : maybe(() => data.producttag.products.pageInfo);

                        const handleCategoriesUnassign = (ids: string[]) =>
                          saleCataloguesRemove({
                            variables: {
                              ...paginationState,
                              producttagId: id,
                              input: {
                                categories: ids
                              }
                            }
                          });

                        const handleCollectionsUnassign = (ids: string[]) =>
                          saleCataloguesRemove({
                            variables: {
                              ...paginationState,
                              producttagId: id,
                              input: {
                                collections: ids
                              }
                            }
                          });

                        const handleProductsUnassign = (ids: string[]) =>
                          saleCataloguesRemove({
                            variables: {
                              ...paginationState,
                              producttagId: id,
                              input: {
                                product: ids
                              }
                            }
                          });

                        const handleVariantsUnassign = (ids: string[]) =>
                          saleCataloguesRemove({
                            variables: {
                              ...paginationState,
                              producttagId: id,
                              input: {
                                productvariant: ids
                              }
                            }
                          });

                        const handleSubmit = async (
                          productTagsData: ProductTagDetailsPageFormData
                        ) => {
                          const result = await saleUpdate({
                            variables: {
                              id,
                              input: {
                                tagType: TagValueTypeEnum(
                                  productTagsData.tagType
                                ),
                                title: productTagsData.title,
                                name: productTagsData.name,
                                stickersImage: productTagsData.stickersImage,
                                stickersImageLocationX:
                                  productTagsData.stickersImageLocationX,
                                stickersImageLocationY:
                                  productTagsData.stickersImageLocationY,
                                showTag: productTagsData.showTag,
                                componentFontColor:
                                  productTagsData.componentFontColor,
                                productFontColor:
                                  productTagsData.productFontColor,
                                productBackgroundColor:
                                  productTagsData.productBackgroundColor
                              }
                            }
                          });

                          return result.data.producttagsUpdate.errors;
                        };

                        const {
                          loadNextPage,
                          loadPreviousPage,
                          pageInfo
                        } = paginate(tabPageInfo, paginationState, params);
                        return (
                          <>
                            <WindowTitle
                              title={intl.formatMessage(sectionNames.sales)}
                            />
                            <SaleDetailsPage
                              // defaultCurrency={maybe(
                              //   () => shop.defaultCurrency
                              // )}
                              Producttag={maybe(() => data.producttag)}
                              disabled={
                                loading || saleCataloguesRemoveOpts.loading
                              }
                              errors={
                                saleUpdateOpts.data?.producttagsUpdate.errors ||
                                []
                              }
                              // fetchCornermarks={searchCornermark}
                              // fetchMoreCornermarks={{
                              //   hasMore:
                              //     searchCornermarkOpts.data?.search.pageInfo
                              //       .hasNextPage,
                              //   loading: searchCornermarkOpts.loading,
                              //   onFetchMore: loadMoreCornermarks
                              // }}
                              // cornermarks={(
                              //   searchCornermarkOpts.data?.search.edges ||
                              //   []
                              // ).map(edge => edge.node)}
                              pageInfo={pageInfo}
                              onNextPage={loadNextPage}
                              onPreviousPage={loadPreviousPage}
                              onCategoryAssign={() =>
                                openModal("assign-category")
                              }
                              onCategoryClick={id => () =>
                                navigate(categoryUrl(id))}
                              onCollectionAssign={() =>
                                openModal("assign-collection")
                              }
                              onCollectionUnassign={collectionId =>
                                handleCollectionsUnassign([collectionId])
                              }
                              onCategoryUnassign={categoryId =>
                                handleCategoriesUnassign([categoryId])
                              }
                              onCollectionClick={id => () =>
                                navigate(collectionUrl(id))}
                              onProductAssign={() =>
                                openModal("assign-product")
                              }
                              onProductUnassign={productId =>
                                handleProductsUnassign([productId])
                              }
                              onProductClick={id => () =>
                                navigate(productUrl(id))}
                              // onSaleProductAssign={() =>
                              //   openModal("assign-product")
                              // }
                              // onSaleProductUnassign={productId =>
                              //   handleSaleProductsUnassign([productId])
                              // }
                              onVariantAssign={() =>
                                openModal("assign-variant")
                              }
                              onVariantUnassign={variantId =>
                                handleVariantsUnassign([variantId])
                              }
                              onVariantClick={(productId, variantId) => () =>
                                navigate(
                                  productVariantEditUrl(productId, variantId)
                                )}
                              activeTab={params.activeTab}
                              onBack={() => navigate(producttagsListUrl())}
                              onTabClick={changeTab}
                              onSubmit={handleSubmit}
                              onRemove={() => openModal("remove")}
                              saveButtonBarState={
                                saleUpdateOpts.status
                                // ||
                                // saleProductUpdateOpts.status
                              }
                              categoryListToolbar={
                                <Button
                                  color="primary"
                                  onClick={() =>
                                    openModal("unassign-category", {
                                      ids: listElements
                                    })
                                  }
                                >
                                  <FormattedMessage
                                    defaultMessage="Unassign"
                                    description="unassign category from sale, button"
                                    id="saleDetailsUnassignCategory"
                                  />
                                </Button>
                              }
                              variantListToolbar={
                                <Button
                                  color="primary"
                                  onClick={() =>
                                    openModal("unassign-variant", {
                                      ids: listElements
                                    })
                                  }
                                >
                                  <FormattedMessage
                                    defaultMessage="Unassign"
                                    description="unassign product sku from sale, button"
                                    id="saleDetailsUnassignVariant"
                                  />
                                </Button>
                              }
                              collectionListToolbar={
                                <Button
                                  color="primary"
                                  onClick={() =>
                                    openModal("unassign-collection", {
                                      ids: listElements
                                    })
                                  }
                                >
                                  <FormattedMessage
                                    defaultMessage="Unassign"
                                    description="unassign collection from sale, button"
                                    id="saleDetailsUnassignCollection"
                                  />
                                </Button>
                              }
                              productListToolbar={
                                <Button
                                  color="primary"
                                  onClick={() =>
                                    openModal("unassign-product", {
                                      ids: listElements
                                    })
                                  }
                                >
                                  <FormattedMessage
                                    defaultMessage="Unassign"
                                    description="unassign product from sale, button"
                                    id="saleDetailsUnassignProduct"
                                  />
                                </Button>
                              }
                              isChecked={isSelected}
                              selected={listElements.length}
                              toggle={toggle}
                              toggleAll={toggleAll}
                            />
                            <AssignVariantDialog
                              confirmButtonState={saleCataloguesAddOpts.status}
                              hasMore={
                                searchProductVariantsOpts.data?.search?.pageInfo
                                  .hasNextPage
                              }
                              open={params.action === "assign-variant"}
                              onFetch={searchProductVariants}
                              onFetchMore={loadMoreProductVariants}
                              loading={searchProductVariantsOpts.loading}
                              onClose={closeModal}
                              onSubmit={variants =>
                                saleCataloguesAdd({
                                  variables: {
                                    ...paginationState,
                                    producttag: id,
                                    input: {
                                      productvariant: variants.map(
                                        variant => variant.id
                                      )
                                    }
                                  }
                                })
                              }
                              variants={mapEdgesToItems(
                                searchProductVariantsOpts?.data?.search
                              )?.filter(
                                suggestedVariant => suggestedVariant.id
                              )}
                            />

                            <AssignProductDialog
                              confirmButtonState={saleCataloguesAddOpts.status}
                              hasMore={
                                searchProductsOpts.data?.search?.pageInfo
                                  .hasNextPage
                              }
                              open={params.action === "assign-product"}
                              onFetch={searchProducts}
                              onFetchMore={loadMoreProducts}
                              loading={searchProductsOpts.loading}
                              onClose={closeModal}
                              onSubmit={products =>
                                saleCataloguesAdd({
                                  variables: {
                                    ...paginationState,
                                    producttag: id,
                                    input: {
                                      product: products.map(
                                        product => product.id
                                      )
                                    }
                                  }
                                })
                              }
                              products={mapEdgesToItems(
                                searchProductsOpts?.data?.search
                              )?.filter(
                                suggestedProduct => suggestedProduct.id
                              )}
                            />
                            <AssignCategoriesDialog
                              categories={maybe(() =>
                                searchCategoriesOpts.data.search.edges
                                  .map(edge => edge.node)
                                  .filter(
                                    suggestedCategory => suggestedCategory.id
                                  )
                              )}
                              confirmButtonState={saleCataloguesAddOpts.status}
                              hasMore={
                                searchCategoriesOpts.data?.search.pageInfo
                                  .hasNextPage
                              }
                              open={params.action === "assign-category"}
                              onFetch={searchCategories}
                              onFetchMore={loadMoreCategories}
                              loading={searchCategoriesOpts.loading}
                              onClose={closeModal}
                              onSubmit={categories =>
                                saleCataloguesAdd({
                                  variables: {
                                    ...paginationState,
                                    producttag: id,
                                    input: {
                                      categories
                                    }
                                  }
                                })
                              }
                            />
                            <AssignCollectionDialog
                              collections={maybe(() =>
                                searchCollectionsOpts.data.search.edges
                                  .map(edge => edge.node)
                                  .filter(
                                    suggestedCategory => suggestedCategory.id
                                  )
                              )}
                              confirmButtonState={saleCataloguesAddOpts.status}
                              hasMore={
                                searchCollectionsOpts.data?.search.pageInfo
                                  .hasNextPage
                              }
                              open={params.action === "assign-collection"}
                              onFetch={searchCollections}
                              onFetchMore={loadMoreCollections}
                              loading={searchCollectionsOpts.loading}
                              onClose={closeModal}
                              onSubmit={collections =>
                                saleCataloguesAdd({
                                  variables: {
                                    ...paginationState,
                                    producttag: id,
                                    input: {
                                      collections
                                    }
                                  }
                                })
                              }
                            />
                            <ActionDialog
                              open={
                                params.action === "unassign-category" &&
                                canOpenBulkActionDialog
                              }
                              title={intl.formatMessage({
                                defaultMessage: "Unassign Categories From Sale",
                                description: "dialog header"
                              })}
                              confirmButtonState={
                                saleCataloguesRemoveOpts.status
                              }
                              onClose={closeModal}
                              onConfirm={() =>
                                handleCategoriesUnassign(params.ids)
                              }
                            >
                              {canOpenBulkActionDialog && (
                                <DialogContentText>
                                  <FormattedMessage
                                    defaultMessage="{counter,plural,one{Are you sure you want to unassign this category?} other{Are you sure you want to unassign {displayQuantity} categories?}}"
                                    description="dialog content"
                                    values={{
                                      counter: params.ids.length,
                                      displayQuantity: (
                                        <strong>{params.ids.length}</strong>
                                      )
                                    }}
                                  />
                                </DialogContentText>
                              )}
                            </ActionDialog>
                            <ActionDialog
                              open={
                                params.action === "unassign-collection" &&
                                canOpenBulkActionDialog
                              }
                              title={intl.formatMessage({
                                defaultMessage:
                                  "Unassign Collections From Sale",
                                description: "dialog header"
                              })}
                              confirmButtonState={
                                saleCataloguesRemoveOpts.status
                              }
                              onClose={closeModal}
                              onConfirm={() =>
                                handleCollectionsUnassign(params.ids)
                              }
                            >
                              {canOpenBulkActionDialog && (
                                <DialogContentText>
                                  <FormattedMessage
                                    defaultMessage="{counter,plural,one{Are you sure you want to unassign this collection?} other{Are you sure you want to unassign {displayQuantity} collections?}}"
                                    description="dialog content"
                                    values={{
                                      counter: params.ids.length,
                                      displayQuantity: (
                                        <strong>{params.ids.length}</strong>
                                      )
                                    }}
                                  />
                                </DialogContentText>
                              )}
                            </ActionDialog>
                            <ActionDialog
                              open={
                                params.action === "unassign-product" &&
                                canOpenBulkActionDialog
                              }
                              title={intl.formatMessage({
                                defaultMessage:
                                  "Unassign Products From productTags",
                                description: "dialog header"
                              })}
                              confirmButtonState={
                                saleCataloguesRemoveOpts.status
                              }
                              onClose={closeModal}
                              onConfirm={() =>
                                handleProductsUnassign(params.ids)
                              }
                            >
                              {canOpenBulkActionDialog && (
                                <DialogContentText>
                                  <FormattedMessage
                                    defaultMessage="{counter,plural,one{Are you sure you want to unassign this product?} other{Are you sure you want to unassign {displayQuantity} products?}}"
                                    description="dialog content"
                                    values={{
                                      counter: params.ids.length,
                                      displayQuantity: (
                                        <strong>{params.ids.length}</strong>
                                      )
                                    }}
                                  />
                                </DialogContentText>
                              )}
                            </ActionDialog>
                            <ActionDialog
                              open={
                                params.action === "unassign-variant" &&
                                canOpenBulkActionDialog
                              }
                              title={intl.formatMessage({
                                defaultMessage:
                                  "Unassign variant From productTags",
                                description: "dialog header"
                              })}
                              confirmButtonState={
                                saleCataloguesRemoveOpts.status
                              }
                              onClose={closeModal}
                              onConfirm={() =>
                                handleVariantsUnassign(params.ids)
                              }
                            >
                              {canOpenBulkActionDialog && (
                                <DialogContentText>
                                  <FormattedMessage
                                    defaultMessage="{counter,plural,one{Are you sure you want to unassign this variant?} other{Are you sure you want to unassign {displayQuantity} variant?}}"
                                    description="dialog content"
                                    values={{
                                      counter: params.ids.length,
                                      displayQuantity: (
                                        <strong>{params.ids.length}</strong>
                                      )
                                    }}
                                  />
                                </DialogContentText>
                              )}
                            </ActionDialog>
                            <ActionDialog
                              open={params.action === "remove"}
                              title={intl.formatMessage({
                                defaultMessage: "Delete productTag",
                                description: "dialog header"
                              })}
                              confirmButtonState={RemoveProducttagsOpts.status}
                              onClose={closeModal}
                              variant="delete"
                              onConfirm={() =>
                                removeProducttags({
                                  variables: { id }
                                })
                              }
                            >
                              <DialogContentText>
                                <FormattedMessage
                                  defaultMessage="Are you sure you want to delete {saleName}?"
                                  description="dialog content"
                                  values={{
                                    saleName: (
                                      <strong>
                                        {maybe(
                                          () => data.producttag.name,
                                          "..."
                                        )}
                                      </strong>
                                    )
                                  }}
                                />
                              </DialogContentText>
                            </ActionDialog>
                          </>
                        );
                      }}
                    </TypedproducttagQuery>
                    //   )}
                    // </TypedproducttagsUpdateMutation>
                    //   )}
                    // </TypedSaleProductUpdate>
                  )}
                </TypedRemoveProducttags>
              )}
            </TypedproducttagsUpdateMutation>
          )}
        </TypedproducttagsAddCataloguesMutation>
      )}
    </TypedproducttagsDeleteCataloguesMutation>
  );
};
export default SaleDetails;
